export default __webpack_public_path__ + "web/react/components/follow-designer-send-to-app-modal/images/follow-image1.9024c3fd4fc72f4f5fa80829340901c9.png";